import * as stores from './stores'

export default {
  stores,
}
